import * as React from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";

import { enqueueSnackbar } from "./../slices/notifications";
import { signIn } from "./../slices/auth";
import { canopy } from "./../theme";
import AuthLayout from "./AuthLayout";

export default function SignIn() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    try {
      await dispatch(
        signIn({
          email: data.get("email"),
          password: data.get("password"),
        }),
      ).unwrap();

      const from = location.state?.from?.pathname || "/account";
      navigate(from, { replace: true });
    } catch (error) {
      dispatch(
        enqueueSnackbar({
          message: `Failed to sign in: ${error}`,
          options: {
            variant: "error",
          },
        }),
      );
    }
  };

  return (
    <AuthLayout subtitle="Welcome home">
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 4 }}>
        <Stack spacing={2}>
          <TextField
            required
            fullWidth
            id="email"
            label="Email address"
            name="email"
            autoComplete="email"
            autoFocus
          />
          <TextField
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <Button type="submit" fullWidth variant="contained" size="large">
            Sign in
          </Button>
        </Stack>
        <Stack alignItems="center" spacing={2} sx={{ mt: 3 }}>
          <Link
            to="/reset"
            style={{ color: canopy.green, fontWeight: 700, fontSize: 14, textDecoration: "none" }}
          >
            Forgot password?
          </Link>
          <Typography sx={{ fontSize: 14, color: "text.secondary", fontWeight: 600 }}>
            New to the neighborhood?{" "}
            <Link
              to="/signup"
              style={{ color: canopy.green, fontWeight: 800, textDecoration: "none" }}
            >
              Create an account
            </Link>
          </Typography>
        </Stack>
      </Box>
    </AuthLayout>
  );
}
